<template>
  <div id="home" class="flex-column">
    <div class="home-wrapper">
      <div class="module-switch">
        <div class="switch-btn-wrap" :class="{ 'active': (activeSwitch == index) || (hoverSwitch === index) }"
          v-for="(item, index) in switchList" :key="index" @click="toMainPage(index)" @mouseenter="hoverSwitch = index"
          @mouseleave="hoverSwitch = -1">
          <button class="switch-btn csp">{{ item }}</button>
        </div>
      </div>
      <template
        v-if="currentProject.id == 735 && role == 'teacher' || ignoreProjectIds.includes(currentProject.id)"></template>
      <statisticsCount v-else :projectId='currentProject.id'></statisticsCount>
      <basicsInfo v-if="role != 'manager' && role != 'bc-manager' && role != 'leader' && role != 'school'">
      </basicsInfo>
      <div class="container flex-layout">
        <template
          v-if="currentProject.id == 735 && role == 'teacher' || ignoreProjectIds.includes(currentProject.id)"></template>
        <sidebar v-else v-show="!hideSidebar"></sidebar>
        <router-view class="router-view" :class="{ 'is-student-answer': hideSidebar }"></router-view>
      </div>
    </div>
    <ClassTips></ClassTips>
  </div>
</template>
<script>
  import {
    mapState,
  } from "vuex";
  import basicsInfo from "./baisc-info.vue" // 专家、教师身份个人信息及切换
  import statisticsCount from "./statistics-count.vue" //上部分数据统计
  import sidebar from "./sidebar.vue" //左侧导航栏 领导、管理员身份个人信息及切换
  export default {
    name: "home",
    data() {
      return {
        switchList: ['项目主页', '研修空间'],
        activeSwitch: 1,
        hoverSwitch: -1,
        ignoreProjectIds: [735, 759, 762, , 765, 772, 775, 778, 781, 784, 787, 791]
      };
    },
    computed: {
      ...mapState({
        role: state => state.user.role,
        currentProject: state => state.user.currentProject,
        hasMain: state => state.basics.hasMain
      }),
      hideSidebar() {
        return this.$route.name === 'studentAnswer';
      }
    },
    components: {
      basicsInfo,
      statisticsCount,
      sidebar
    },
    methods: {
      async toMainPage(index) {
        if (index === 0) {
          const projectId = this.currentProject?.id
          const modelType = Number(this.currentProject?.modelType)
          const isNewHomeType = [4, 5, 6, 9].includes(modelType)
          // 研伴/结对/三交/两级工作室：直接进新版项目主页，不查公告
          if (isNewHomeType) {
            this.$router.push(`/projectHome/${projectId}`)
            return
          }
          // 其余类型：有通知公告才视为有主页
          let hasMain = false
          try {
            const resData = await this.$Api.Home.getNewsListByProjectId({
              projectId,
              page: 1,
              limit: 4,
            })
            const list = (resData && resData.data && resData.data.list) || []
            hasMain = Array.isArray(list) && list.length > 0
          } catch (e) {
            hasMain = false
          }
          this.$store.commit('getHasMain', hasMain)
          if (!hasMain) {
            this.$message({
              duration: 1000,
              message: '该项目暂无项目主页',
              type: 'error'
            });
            return;
          }
          this.$router.push(`/main/${projectId}/project`);
          return;
        }
        if (index === 1) {
          // 研修空间
          this.$router.push('/item-list');
          return;
        }
        if (index === 2) {
          // 结对空间
          this.$router.push('/paired');
          return;
        }
      },
      // 按当前项目是否有结对空间，同步顶部「结对空间」Tab
      async getAllSpacesList() {
        const baseTabs = ['项目主页', '研修空间']
        const projectId = this.currentProject?.id
        if (!projectId) {
          this.switchList = baseTabs
          return
        }
        try {
          const res = await this.$Api.Paired.getListByProject({
            page: 1,
            limit: 5,
            projectId,
          })
          const records = (res && res.data && res.data.records) || []
          this.switchList = records.length > 0 ? [...baseTabs, '结对空间'] : baseTabs
        } catch (e) {
          this.switchList = baseTabs
        }
      },
    },
    watch: {
      'currentProject.id': {
        handler() {
          this.getAllSpacesList();
        },
        immediate: true
      },
      $route: {
        handler(to) {
          if (to.path === '/paired') {
            this.activeSwitch = 2;
          } else if (to.path === '/item-list' || to.path.indexOf('/home') === 0) {
            this.activeSwitch = 1;
          } else if (to.path.indexOf('/main/') !== -1 || to.path.indexOf('/projectHome/') !== -1) {
            this.activeSwitch = 0;
          }
        },
        immediate: true
      }
    },
    mounted() {},
    activated() {
      this.getAllSpacesList();
    },
    deactivated() {
      this.activeSwitch = 1;
    },
    // created() {}
  };
</script>

<style lang="less" scoped>
  .home-wrapper {
    width: 990px;
    min-width: 990px;
    margin: 25px auto 100px;
    padding: 0 25px;
    box-sizing: border-box;
    box-shadow: 0px 2px 10px 0px #F5F8FA;
    border-radius: 8px;
  }

  .container {
    flex: 1;
    align-items: flex-start;
  }

  .router-view {
    flex: 1;
    box-shadow: 0px 2px 10px 0px #F5F8FA;
    overflow: hidden;
    margin-bottom: 50px;

    &.is-student-answer {
      overflow: visible;
    }
  }

  .module-switch {
    background-color: #fff;
    border-bottom: 1px solid #F0F0F0;
    line-height: 40px;

    margin: 0px auto 25px;

    .switch-btn-wrap {
      display: inline-block;
      position: relative;

      .switch-btn {
        line-height: 53px;
        font-size: 13px;
        padding: 0 42px;
        position: relative;
      }
    }

    .active {
      .switch-btn {
        color: #508EF9;
      }

      .switch-btn::before {
        content: '';
        height: 2px;
        width: 100%;
        position: absolute;
        bottom: -2px;
        left: 0;
        background-color: #508EF9;
      }
    }

  }

  @media screen and (min-width: 1250px) {
    .home-wrapper {
      width: 1200px;
      padding: 0 30px;
    }

    .module-switch {
      line-height: 48px;
      margin: 31px auto;

      .switch-btn-wrap {
        .switch-btn {
          line-height: 48px;
          font-size: 15px;
          padding: 0 51px;
        }
      }
    }
  }
</style>